import React, { useState } from 'react';
import { chipLabel, presentGaps } from '../../utils/uploadGaps';
import {
  GAP_FEWER,
  GAP_MORE,
  GAP_OPEN_NOTES,
  GAP_PRESSURE_A,
  GAP_PRESSURE_B,
  GAP_PURPOSE_BANNER,
  GAP_SHOW_SCENE,
  GAP_STILL_THIN,
} from '../../utils/writerCopy';
import './UploadSettle.css';

/**
 * Soft settle chips after a Prompt A or B upload.
 * Plot Grid is the Path A room. Framework and Plot Focus are the Path B room.
 */
export default function UploadSettle({
  gaps,
  room = 'plot',
  onFocusScene,
  onOpenNotes,
  povSlot = false,
}) {
  const [expanded, setExpanded] = useState(false);
  const view = presentGaps(gaps, room, { expanded, povSlot });
  if (!view) return null;

  const banner = view.banner === 'purpose'
    ? GAP_PURPOSE_BANNER
    : (view.banner === 'pressure'
      ? (room === 'plot' ? GAP_PRESSURE_A : GAP_PRESSURE_B)
      : '');
  const sceneChips = room === 'plot' ? view.sceneChips : [];

  return (
    <section className="upload-settle" aria-label="Still to settle" data-testid="upload-settle">
      {banner ? (
        <p className="upload-settle__banner" role="status" data-testid="upload-settle-banner">
          {banner}
        </p>
      ) : null}
      {room === 'plot' && view.banner === 'purpose' && view.focusSceneId && onFocusScene ? (
        <button
          type="button"
          className="upload-settle__show"
          onClick={() => onFocusScene(view.focusSceneId)}
        >
          {GAP_SHOW_SCENE}
        </button>
      ) : null}
      {view.pressure.length > 0 ? (
        <div className="upload-settle__strip" aria-label={GAP_STILL_THIN} data-testid="upload-settle-pressure">
          <p className="upload-settle__strip-label">{GAP_STILL_THIN}</p>
          <ul className="upload-settle__chips">
            {view.pressure.map((chip) => (
              <li key={chip.kind}>
                {onOpenNotes ? (
                  <button
                    type="button"
                    className="upload-settle__chip"
                    data-testid={`upload-settle-chip-${chip.kind}`}
                    onClick={onOpenNotes}
                  >
                    {chipLabel(chip)}
                  </button>
                ) : (
                  <span
                    className="upload-settle__chip upload-settle__chip--quiet"
                    data-testid={`upload-settle-chip-${chip.kind}`}
                  >
                    {chipLabel(chip)}
                  </span>
                )}
              </li>
            ))}
          </ul>
          {onOpenNotes ? (
            <button type="button" className="upload-settle__notes" onClick={onOpenNotes}>
              {GAP_OPEN_NOTES}
            </button>
          ) : null}
        </div>
      ) : null}
      {sceneChips.length > 0 ? (
        <ul className="upload-settle__chips">
          {sceneChips.map((chip, index) => (
            <li key={`${chip.kind}-${chip.scene_id || index}`}>
              <button
                type="button"
                className="upload-settle__chip"
                onClick={() => chip.scene_id && onFocusScene?.(chip.scene_id)}
              >
                {chipLabel(chip)}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      {view.hidden > 0 || expanded ? (
        <button
          type="button"
          className="upload-settle__more"
          data-testid="upload-settle-more"
          aria-expanded={expanded}
          onClick={() => setExpanded((open) => !open)}
        >
          {expanded ? GAP_FEWER : GAP_MORE}
        </button>
      ) : null}
    </section>
  );
}
